import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "calendar-cells" }
const _hoisted_2 = { class: "calendar-cell-day" }

import { addDays, format, isSameDay, isSameMonth, isToday } from 'date-fns'
  import { Ref, ref, toRefs, watch, onMounted } from 'vue'

  import CalendarWorkouts from '@/components/Dashboard/UserCalendar/CalendarWorkouts.vue'
  import { ISport } from '@/types/sports'
  import { IWorkout } from '@/types/workouts'
  import { getDateWithTZ } from '@/utils/dates'

  interface Props {
    currentDay: Date
    endDate: Date
    sports: ISport[]
    startDate: Date
    timezone: string
    weekStartingMonday: boolean
    workouts: IWorkout[]
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    currentDay: null,
    endDate: null,
    sports: null,
    startDate: null,
    timezone: null,
    weekStartingMonday: { type: Boolean },
    workouts: null
  },
  setup(__props: any) {

const props = __props as {
    currentDay: Date
    endDate: Date
    sports: ISport[]
    startDate: Date
    timezone: string
    weekStartingMonday: boolean
    workouts: IWorkout[]
  }

  

  const {
    currentDay,
    endDate,
    sports,
    startDate,
    timezone,
    weekStartingMonday,
    workouts,
  } = toRefs(props)
  const rows: Ref<Date[][]> = ref([])

  onMounted(() => getDays())

  function getDays() {
    rows.value = []
    let day = startDate.value
    while (day <= endDate.value) {
      const days: Date[] = []
      for (let i = 0; i < 7; i++) {
        days.push(day)
        day = addDays(day, 1)
      }
      rows.value.push(days)
    }
  }
  function isWeekEnd(day: number): boolean {
    return weekStartingMonday.value
      ? [5, 6].includes(day)
      : [0, 6].includes(day)
  }
  function filterWorkouts(day: Date, workouts: IWorkout[]) {
    if (workouts) {
      return workouts
        .filter((workout) =>
          isSameDay(getDateWithTZ(workout.workout_date, timezone), day)
        )
        .reverse()
    }
    return []
  }

  watch(
    () => props.currentDay,
    () => getDays()
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "calendar-row",
        key: index
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (day, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["calendar-cell", {
          'disabled-cell': !_unref(isSameMonth)(day, _unref(currentDay)),
          'week-end': isWeekEnd(i),
          today: _unref(isToday)(day),
        }]),
            key: i
          }, [
            _createVNode(CalendarWorkouts, {
              workouts: filterWorkouts(day, _unref(workouts)),
              sports: _unref(sports)
            }, null, 8, ["workouts", "sports"]),
            _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(format)(day, 'd')), 1)
          ], 2))
        }), 128))
      ]))
    }), 128))
  ]))
}
}

})